import LazyLoad, {
  ILazyLoadInstance,
  ILazyLoadOptions,
} from "vanilla-lazyload";

export default class TemplateLazyLoad {
  private readonly loader: ILazyLoadInstance;

  constructor(selector: string, container: HTMLElement = null) {
    const options: ILazyLoadOptions = {
      elements_selector: selector,
      callback_loaded: (element) => this.onImageLoad(element),
    };
    if (container !== null) {
      options.container = container;
    }
    this.loader = new LazyLoad(options);
    this.loader.update();
  }

  public Destroy(): void {
    this.loader.destroy();
  }

  private async onImageLoad(element: HTMLElement): Promise<void> {
    const imageContainer = $(element).closest(".image-row");
    imageContainer.find(".image-placeholder").remove();
    $(element).attr("src", element.dataset.src);
  }
}
